import { Skeleton, styled } from '@ori-ui/mui';

export const UnifiedSkeleton = styled(Skeleton)({ transform: 'none' });
